import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import "./scss/main.css";
import IframeGame from "./Components/IframeGame/IframeGame.jsx";
import NotFound from "./Components/NotFound/NotFound.jsx";
import PaymentContent from "./Components/Payment/PaymentContent.jsx";
import Shopping from "./Components/Shopping/Shopping.jsx";
import WishList from "./Components/WishList/WishList.jsx";
import AuthLayOut from "./LayOuts/AuthLayOut.jsx";
import PaymentLayOut from "./LayOuts/PaymentLayOut.jsx";
import RootLayOut from "./LayOuts/RootLayOut.jsx";
import AndroidGamesPage from "./Pages/AndroidGamesPage/AndroidGamesPage";
import Home from "./Pages/HomePage/Home";
import Html5Games from "./Pages/Html5Games/Html5Games";
import MyTournamentsPage from "./Pages/MyTournamentsPage/MyTournamentsPage";
import OtpCode from "./Pages/OtpCode/OtpCode.jsx";
import PayOrPlay from "./Pages/PayOrPlay/PayOrPlay";
import Profile from "./Pages/Profile/Profile";
import RateUs from "./Pages/RateUs/RateUs.jsx";
import Settings from "./Pages/Settings/Settings";
import Store from "./Pages/Store/Store";
import Success from "./Pages/Success/Success.jsx";
import SuccessMsg from "./Pages/SuccessMsg/SuccessMsg.jsx";
import IraqConfirm from "./Pages/SignUp/aciqSignup/IraqConfirm.jsx";
import AciqVerify from "./Pages/SignUp/aciqSignup/aciqVerify.jsx";

import TheWar from "./Pages/TheWar/TheWar.jsx";
import VoucherGame from "./Pages/Voucher_game/VoucherGame.jsx";
import RequiredAuth from "./Utilies/RequiredAuth.js";
// import MatchMaking from "./Components/MatchMaking/MatchMaking.jsx";
import BattlesComponent from "./Components/BattlesComponent/BattlesComponent.jsx";
import MyTournaments from "./Components/tournamentsSection/MyTournaments.jsx";
import BattlesAndTournsLayOut from "./LayOuts/BattlesAndTournsLayOut.jsx";
import SecondCart from "./Components/SecondCart/SecondCart.jsx";
import DeafultPayment from "./Components/DeafultPayment/DeafultPayment.jsx";
import AndroidGameDetails from "./Pages/GameItemDetails/AndroidGameDetails.jsx";
import HtmlGameDetails from "./Pages/GameItemDetails/HtmlGameDetails.jsx";
import {
  getHostComponentByRoute,
  getHostSigninComponentByRoute,
  getHostSuccessComponentByRoute,
  getSignup2ComponentByHost,
} from "../src/Utilies/RoutesHelper.js";
import Privacy from "./Pages/SignUp/Privacy";
import Terms from "./Pages/SignUp/Terms";
import KorekVerify from "./Pages/SignUp/korek/korek-verify.jsx";
import KsaVerify from "./Pages/SignUp/KsaSignup/KsaVerify.jsx";
import KsaSuccess from "./Pages/SignUp/KsaSignup/KsaSuccess.jsx";
import SuccessKorek from "./Pages/SignUp/korek/korek-success.jsx";
import FailPageKorek from "./Pages/SignUp/korek/korek-fail.jsx";
import PinCodePage from "./Pages/SignUp/zain-iraq/PinCodePage";
import FailPage from "./Pages/SignUp/zain-iraq/FailPage";
import ThankyouPage from "./Pages/SignUp/zain-iraq/ThankyouPage";
import KsaFail from "./Pages/SignUp/KsaSignup/KsaFail.jsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import TermsAndConditions from "./Pages/SignUp/korek/TermsAndConditions.jsx";
import TermsWorldLink from "./Pages/SignUp/TermsWorldLink.jsx";
import AciqTermsAndConditions from "./Pages/SignUp/aciqSignup/TermsAndConditions.jsx";
import AciqPrivacy from "./Pages/SignUp/aciqSignup/PolicyAndPrivacy.jsx";
import PolicyAndPrivacy from "./Pages/SignUp/korek/PolicyAndPrivacy.jsx";
import SignUpNewdzo from "./Pages/SignUp/SignUpNewdzo.jsx";
import DzoSignin2 from "./Pages/SignIn/DzoSignin/DzoSignin2.jsx";
import KsaLebaraVerify from "./Pages/SignUp/ksa/KsaLebaraVerify";
import MtnzaStatus from "./Pages/SignUp/southAfrica/MtnzaStatus.jsx";
import MarketingPage from "./Pages/Marketing/MarketingPage.jsx";
import Marketing2Page from "./Pages/Marketing/Marketing2Page.jsx";
import Marketing3Page from "./Pages/Marketing/Marketing3Page.jsx";
import Marketing4Page from "./Pages/Marketing/Marketing4Page.jsx";
import DzoUnsubscribe from "./Pages/Unsubscribe/DzoUnsubscribe.jsx";
function App() {
  const { i18n } = useTranslation();

  let hostname = window.location.hostname;
 useEffect(() => {
  const isMtnza = hostname.includes("mtnza");

  if (isMtnza) {
    localStorage.setItem("i18nextLng", "en");
    i18n.changeLanguage("en");
    document.body.dir = "ltr";
    return;
  }

  const isZiq = hostname.includes("ziq")|| hostname.includes("aciq") || hostname.includes("libyad")|| hostname.includes("lebara") || hostname.includes("localhost") || hostname.includes("gamerclub.ly");

  let saved = localStorage.getItem("i18nextLng");

  if (saved === "en-US") saved = "en";

  if (!saved) {
    saved = isZiq ? "ar" : "en";
    localStorage.setItem("i18nextLng", saved);
  }

  i18n.changeLanguage(saved);
}, [i18n, hostname]);

  const routes = createBrowserRouter([
    {
      path: "/",
      element: <RootLayOut />,
      children: [
        { index: true, element: <Home /> },
        { path: "home", element: <Home /> },
        { path: "payorplay/all", element: <PayOrPlay /> },
        { path: "payorplay/:cat", element: <PayOrPlay /> },
        { path: "store", element: <Store /> },
        { path: "html5games", element: <Html5Games /> },
        { path: "android", element: <AndroidGamesPage /> },
        { path: "androidGameDetails/:gameId", element: <AndroidGameDetails /> },
        { path: "htmlGameDetails/:gameId", element: <HtmlGameDetails /> },
        { path: "rateUs", element: <RateUs /> },
        { path: "successMsg", element: <SuccessMsg /> },
        {
          path: "mytournaments",
          element: (
            <RequiredAuth>
              <MyTournamentsPage />
            </RequiredAuth>
          ),
        },
        {
          path: "battles-tournaments/:sectionType/theWar/:id",
          element: (
            <RequiredAuth>
              <TheWar />
            </RequiredAuth>
          ),
        },
        {
          path: "voucher/:id",
          element: <VoucherGame />,
        },
        {
          path: "settings",
          element: (
            <RequiredAuth>
              <Settings />
            </RequiredAuth>
          ),
        },
        {
          path: "profile",
          element: (
            <RequiredAuth>
              <Profile />
            </RequiredAuth>
          ),
        },
        { path: "*", element: <NotFound /> },
      ],
    },
    {
      path: "/",
      element: <AuthLayOut />,
      children: [
        { index: true, element: getHostSigninComponentByRoute("signIn") },
        { path: "signIn", element: getHostSigninComponentByRoute("signIn") },
        { path: "signup", element: getHostComponentByRoute("signup") },
        { path: "signup2", element: getSignup2ComponentByHost() },
        { path: "procedding2", element: <SignUpNewdzo /> },
        { path: "signin2", element: <DzoSignin2 /> },
        { path: "separatedunsub", element: <DzoUnsubscribe /> },
        { path: "confirm-asiacell", element: <IraqConfirm /> },

        { path: "korek-verify", element: <KorekVerify /> },
        { path: "korek-fail", element: <FailPageKorek /> },
        { path: "korek-success", element: <SuccessKorek /> },
        { path: "ksa-verify", element: <KsaVerify /> },
        { path: "ksa-lebara-verify", element: <KsaLebaraVerify /> },
         { path: "status", element: <MtnzaStatus /> },
        { path: "ksa-success", element: <KsaSuccess /> },
        { path: "ksa-fail", element: <KsaFail /> },
        { path: "proceeding", element: getHostComponentByRoute("signup") },
        /* { path: "marketing", element: <MarketingPage /> }, */
        { path: "marketing1", element: <Marketing2Page /> },
        { path: "marketing2", element: <Marketing3Page /> },
        /* { path: "marketing4", element: <Marketing4Page /> }, */
        { path: "zain-fail", element: <FailPage /> },
        { path: "zain-verify", element: <PinCodePage /> },
        { path: "otp", element: <OtpCode /> },
        { path: "privacy", element: <Privacy /> },
        { path: "terms", element: <Terms /> },
        { path: "terms-world-link", element: <TermsWorldLink /> },
        { path: "terms-and-conditions", element: <TermsAndConditions /> },
        {
          path: "aciq-terms-and-conditions",
          element: <AciqTermsAndConditions />,
        },
        {
          path: "aciq-policy-and-privacy",
          element: <AciqPrivacy />,
        },
        { path: "verify-asiacell", element: <AciqVerify /> },

        { path: "policy-and-privacy", element: <PolicyAndPrivacy /> },
        { path: "success", element: getHostSuccessComponentByRoute("success") },
        { path: "play/:id", element: <IframeGame /> },
        {
          path: `battles-tournaments/:sectionType/theWar/:tournId/:gameId`,
          element: (
            <IframeGame />
            // <RequiredAuth>
            // 	<MatchMaking />
            // </RequiredAuth>
          ),
        },
      ],
    },
    {
      path: "/",
      element: <BattlesAndTournsLayOut />,
      children: [
        { path: "battles-tournaments/battles", element: <BattlesComponent /> },
        { path: "battles-tournaments/tournamnets", element: <MyTournaments /> },
      ],
    },
    {
      path: "/profile",
      element: <Profile />,
    },
    {
      path: "/secondCart",
      element: <SecondCart />,
    },
    {
      path: "/",
      element: <PaymentLayOut />,
      children: [
        {
          path: "defaultPayment",
          element: <DeafultPayment />,
        },
        {
          path: "paymentContent",
          element: (
            <RequiredAuth>
              <PaymentContent />
            </RequiredAuth>
          ),
        },
        {
          path: "wishlist",
          element: (
            <RequiredAuth>
              <WishList />
            </RequiredAuth>
          ),
        },
        {
          path: "shopping",
          element: (
            <RequiredAuth>
              <Shopping />
            </RequiredAuth>
          ),
        },
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={routes} />
      <ToastContainer />
    </>
  );
}

export default App;
